<template>
  <div >
    <form @submit.prevent class="login-form-box login-pagegap">
      <div class="logo-img">
        <v-img
          max-height="60"
          max-width="230"
          :src="logo_image"
          :lazy-src="logo_image"
        >
        </v-img>
      </div>
      <h4 class="welcome-text">Welcome Admin World!</h4>
      <v-row>
        <v-col cols="7">
          <v-text-field
            class="p-0 m-0"
            v-model="email"
            :error-messages="emailErrors"
            label="Email Address*"
            placeholder="Enter Email"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="7" class="relative col passwordbox">
          <v-text-field
            :type="show_password ? 'text' : 'password'"
            v-model="password"
            :error-messages="passwordErrors"
            label="Password*"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @click:append="show_password = !show_password"
            placeholder="Enter Password"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="5">
          <v-checkbox
            v-model="remember_me"
            label="Remember me"
            class="m-0"
          ></v-checkbox>
        </v-col>
        <v-col   class="text-left">
          <v-btn class="forgotpassword-link" >
            Forgot Password?
          </v-btn>
        </v-col>
      </v-row>
      <span
        v-bind:class="{ 'error-messagebox-login': isAddClassServerError }"
        id="server_side_error"
        >{{ serverError }}</span
      >
      <v-row>
        <v-col>
          <v-btn
            class="blue-btn"
            @click="submit"
            :disabled="!isFormValid"
            :error-messages="buttonErrorMessage"
          >
            sign in
          </v-btn>
        </v-col>
      </v-row>
    </form>
    </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  numeric,
} from "vuelidate/lib/validators";
import axios from "axios";
import JwtService from ".././common/jwt.service";
export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(8),
      validateString: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[#?!@$%^&*-]/.test(value);
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        );
      },
    },
  },

  data: () => ({
    email: "",
    password: "",
    remember_me: false,
    passwordType: "password",
    status: "Show Password",
    btnText: "Show",
    show_password: false,
    show_confirm_password: false,
    image: require("@/assets/images/logo.png"),
    serverError: "",
    date: "",
    isFormValid: true,
    isAddClassServerError: false,
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
    error_message: "",
    success_message: ""
  }),

  mounted() {},

  computed: {
    emailErrors() {
      const errors = [];
      this.serverError = "";
      this.isAddClassServerError = "";
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email is required");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      this.serverError = "";
      this.isAddClassServerError = "";
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required.");
      !this.$v.password.minLength;
      !this.$v.password.validateString;
      return errors;
    },
    buttonErrorMessage() {
      if (this.$v.$invalid) {
        this.isFormValid = false;
      } else {
        this.isFormValid = true;
      }
    },
  },
  methods:{
      submit(){
         this.onClickRememberme();
          this.$loading(true);
          let formdata = new FormData();
            formdata.append(
              "email",
              this.email
            );
            formdata.append("password", this.password);
            axios
              .post(
                process.env.VUE_APP_ROOT_API + "admin/login",
                formdata,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    "Access-Control-Allow-Origin": "*",
                  },
                }
              )
              .then((response) => {
                    if(response.data.status=='success'){
                      localStorage.setItem('marketing_data', '')
                      localStorage.setItem('token',response.data.data.token)
                      this.$router.push({ name: "AdminDashboard" }).catch(() => {});
                    }
                    else{
                      this.error_message= 'Invalid username or password.'
                    }
              })
              .catch((error)=> {
                this.$loading(false);
              });

        },
    onClickRememberme() {
      if (this.remember_me) {
        JwtService.setAdminEmail(btoa(this.email));
       
      } else if (!this.remember_me) {
        JwtService.setAdminEmail("");
        // JwtService.setCompanyPass("");
        // JwtService.getAdminRememberMe("");
      }
    },
  },
  
};
</script>

